export enum SidePanelActionType {//eslint-disable-line @stencil-community/ban-exported-const-enums
  //FIXME CONST ENUM JEST ZABRONIONE
  SidePanelClick = 'Side_Panel_click',
  SidePanelOpen = 'Side_Panel_open',
  SidePanelClose = 'Side_Panel_close'
}
